{
  "oiv.app.mobiliar": "die Mobiliar",
  "oiv.app.protekta": "Protekta",
  "oiv.app.title": "Allgemeine Bedingungen",
  "oiv.button.close": "Schliessen",
  "oiv.error.avbNotFound": "AVB nicht gefunden",
  "oiv.error.eId.notFound": "Die angeforderte Inhaltsreferenz (eID) wurde nicht gefunden",
  "oiv.error.forbidden": "Sie haben keine Berechtigung, um auf diese Ressource zuzugreifen",
  "oiv.error.general": "Entschuldigung, etwas ist schiefgegangen",
  "oiv.error.indexInfoNotFound": "Suchindex nicht gefunden",
  "oiv.footer.company.name": "Protekta Rechtsschutz-Versicherung AG",
  "oiv.footer.contactAndFeedback": "Services & Kontakt",
  "oiv.footer.contactAndFeedback.link": "https://www.mobiliar.ch/kontakt",
  "oiv.footer.dataProtection": "Datenschutz",
  "oiv.footer.dataprotection.link": "https://www.mobiliar.ch/datenschutz",
  "oiv.footer.imprint": "Impressum",
  "oiv.footer.imprint.link": "https://www.mobiliar.ch/impressum",
  "oiv.footer.instruction": "Nutzungshinweise",
  "oiv.footer.instruction.p1": "Bitte beachten Sie, dass die Darstellung der digitalen Allgemeinen Bedingungen auf verschiedenen Endgeräten und Browsern unterschiedlich sein kann.",
  "oiv.footer.instruction.p2": "Wir empfehlen Ihnen, die PDF-Version der Allgemeinen Bedingungen in der jeweiligen Sprache herunterzuladen und auf Ihrem Gerät zu speichern, um sicherzustellen, dass Sie die rechtsverbindliche Version zur Verfügung haben.",
  "oiv.footer.instruction.p3": "Sollten aufgrund von Fehlern oder Missverständnissen, die aufgrund der HTML-Darstellung entstehen können, Fragen oder Unklarheiten auftreten, empfehlen wir Ihnen, sich auf die rechtsverbindliche PDF-Version der Allgemeinen Bedingungen zu beziehen.",
  "oiv.footer.legalInfo": "Rechtliche Hinweise",
  "oiv.footer.legalInfo.link": "https://www.mobiliar.ch/rechtliches",
  "oiv.footer.protekta.contactAndFeedback": "Kontakt",
  "oiv.homepage.button.question": "((not in use)) Fragen",
  "oiv.homepage.head.title": "Kundeninformationen und Allgemeine Bedingungen",
  "oiv.homepage.info.paragraph.b2c": "Haben Sie Fragen zu Ihrer Versicherung? Die Allgemeinen Versicherungsbedingungen erlauben ihnen die wichtigsten Informationen einzusehen.",
  "oiv.homepage.info.paragraph.b2e": "Haben Sie Fragen zu Ihrer Versicherung? Die Allgemeinen Versicherungsbedingungen erlauben Ihnen die wichtigsten Informationen einzusehen.",
  "oiv.homepage.notFeelLikeWriting": "((not in use)) Keine Lust zum Schreiben?",
  "oiv.homepage.p.goToTopic": "((not in use)) Kein Problem! Steigen Sie direkt in ein Thema ein.",
  "oiv.homepage.placeholder.textarea": "((not in use)) Beispielfragestellung, welche die Idee vermitteln...",
  "oiv.homepage.title.content": "Inhalt",
  "oiv.indexSearch.error.text": "Bitte versuche Sie es in ein paar Minuten erneut.",
  "oiv.indexSearch.error.title": "Entschuldigung, etwas ist schiefgegangen",
  "oiv.indexSearch.results": "Resultate für",
  "oiv.indexSearch.title": "Suche",
  "oiv.message.copy": "Kopiert!",
  "oiv.message.urlCopy": "URL kopiert!",
  "oiv.navigation.splitButton.menu": "Inhalt",
  "oiv.navigation.splitButton.search": "Suche",
  "oiv.navigation.title.contact": "Kontakt",
  "oiv.navigation.title.contact.link": "https://www.mobiliar.ch/kontakt",
  "oiv.navigation.title.downloadPDF": "PDF herunterladen",
  "oiv.navigation.title.furtherTopics": "Weiterführende Themen",
  "oiv.navigation.title.goToCustomerPortal": "Zum Kundenportal",
  "oiv.navigation.title.goToCustomerPortal.link": "https://www.mobiliar.ch/login",
  "oiv.navigation.title.goToLegalAdviser": "Mobiliar Rechtsratgeber",
  "oiv.navigation.title.requestAdvice": "Hilfe anfordern",
  "oiv.navigation.title.visitProductPage": "Produktseite",
  "oiv.no-permission.title": "Sie haben keinen Zugriff auf diese Seite.\nFalls sie den Zugriff benötigen, bestellen Sie bitte die Rolle \"OIV Approval\".",
  "oiv.not-available.title": "Das Veröffentlichungsdatum für diesen Inhalt wurde noch nicht erreicht.",
  "oiv.not-found.avb-overview": "Übersicht: Allgemeine Bedingungen (www.mobiliar.ch)",
  "oiv.not-found.avb-overview-rednet": "E-Bibliothek: Allgemeine Versicherungsbedingungen",
  "oiv.not-found.avb-overview-rednet.link": "https://services.marketing.mobiliar.ch/de/downloads/e-bibliothek?list.filter=%7B%22mobi:mawi.productgroup%22:%5B%22root.avb.%22%5D,%22censhare:asset.language%22:%5B%22de%22%5D%7D&s.text=&m.fset=true",
  "oiv.not-found.avb-overview.link": "https://mobiliar.ch/avb",
  "oiv.not-found.contact": "Kontakt",
  "oiv.not-found.contact.link": "https://www.mobiliar.ch/kontakt",
  "oiv.not-found.continue": "Weiter",
  "oiv.not-found.customer-portal": "«Meine Mobiliar» Kundenportal",
  "oiv.not-found.customer-portal.link": "https://www.mobiliar.ch/login",
  "oiv.not-found.heading.text": "Die angeforderte Seite konnten wir nicht finden. Bitte probieren Sie eine der folgenden Optionen, damit Sie Ihr Ziel erreichen können.",
  "oiv.not-found.heading.title": "Wir tappen leider im Dunkeln.",
  "oiv.not-found.more-possibilities": "Weitere Einstiegsmöglichkeiten",
  "oiv.not-found.protekta.avb-overview": "Übersicht: Allgemeine Bedingungen (www.protekta.ch)",
  "oiv.placeholder.search": "Was suchen Sie?",
  "oiv.search.error.message": "Bereit zu suchen? Bitte geben Sie Ihren Suchbegriff ein.",
  "oiv.title.collapseAll": "Alle zusammenklappen",
  "oiv.title.expandAll": "Alle ausklappen"
}